/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react'
import { Image } from 'antd'
import { Link } from 'react-router-dom'

type Props = {
  src?: string,
  imgClass?: string,
  className?: string,
  path?: string | any,
}
function Logo({ src, path = -1, imgClass, className }: Props) {
  return (
    <Link to={path!} className={className}>
      <Image alt="logo" src={src || "/assets/logo/estate-plus.png"} preview={false} className={imgClass} />
    </Link>
  )
}

export default Logo